<template>
  <div class="container">
    <img src="https://qn.lavamusic.com/h5-images/618.jpg" alt="" />
    <p @click="toTB" style="top: 29.938%"></p>
    <p @click="toTB" style="top: 38.41%"></p>
    <p @click="toTB" style="top: 46.9%"></p>
    <p @click="toTB" style="top: 55.37%"></p>
    <p @click="toTB" style="top: 65.3%"></p>
    <p @click="toTB" style="top: 72.6%"></p>
    <p @click="toTB" style="top: 82.51%"></p>
    <p @click="toTB" style="top: 90.95%"></p>
  </div>
</template>
<script>
import dsBridge from "dsbridge";
export default {
  name: "TB20220531",
  setup() {
    const toTB = () => {
      const ua = navigator.userAgent;
      if (ua.includes("LAVA")) {
        dsBridge.call("openAction", {
          pageType: 5,
          url: "https://market.m.taobao.com/app/tb-source-app/shopact/pages/index?wh_weex=true&pathInfo=shop/activity&userId=2487209081&shopId=118438392&pageId=339357045&alisite=true",
        });
      } else {
        const a = document.createElement("a");
         a.setAttribute('href','https://market.m.taobao.com/app/tb-source-app/shopact/pages/index?wh_weex=true&pathInfo=shop/activity&userId=2487209081&shopId=118438392&pageId=339357045&alisite=true')
         a.click()
        console.log(a);
        a.remove();
      }
    };
    return { toTB };
  },
};
</script>
<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  height: auto;
  // background: #fef8cf;
}

.container > img {
  width: 100%;
  vertical-align: middle;
  object-fit: fill;
}

.container > p {
  position: absolute;
  left: 50.5%;
  transform: translateX(-50%);
  height: 6.7vw;
  width: 15vw;
  border-radius: 3.5vw;
  text-align: center;
}
</style>